import script from "./newsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./newsDetail.vue?vue&type=script&setup=true&lang=js"

import "./newsDetail.vue?vue&type=style&index=0&id=ba0fed6e&lang=less"
import "./newsDetail.vue?vue&type=style&index=1&id=ba0fed6e&lang=less&scoped=true"

import exportComponent from "D:\\WorkSpace\\girard\\girard-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba0fed6e"]])

export default __exports__